import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

// `numbered` is a Console-managed field; its stored shape isn't guaranteed,
// so accept the common truthy encodings rather than assume a boolean.
const isNumberedTrue = v => v === true || v === 'true' || v === 'yes' || v === 1 || v === '1';

/**
 * Edition treatment for limited editions. Driven by the real Console field
 * `edition_size` (1 = a unique original, >1 = a limited edition), with the
 * optional `numbered` flag. Renders nothing when there's no edition data, so
 * pieces without it are unaffected. A curatorial callout, not a spec row —
 * the one-of-a-kind / limited nature is a gallery selling point.
 */
const SectionEditionMaybe = props => {
  const { publicData } = props;
  const editionSize = Number(publicData?.edition_size);
  const hasEdition = Number.isFinite(editionSize) && editionSize >= 1;

  if (!hasEdition) {
    return null;
  }

  const isUnique = editionSize === 1;
  const numbered = !isUnique && isNumberedTrue(publicData?.numbered);

  return (
    <section className={css.sectionEdition}>
      <span className={css.editionBadge}>
        {isUnique ? (
          <FormattedMessage id="ListingPage.editionUnique" />
        ) : (
          <FormattedMessage id="ListingPage.editionLimited" values={{ count: editionSize }} />
        )}
        {numbered ? (
          <span className={css.editionNumbered}>
            {' · '}
            <FormattedMessage id="ListingPage.editionNumbered" />
          </span>
        ) : null}
      </span>
    </section>
  );
};

export default SectionEditionMaybe;
